export default "__VITE_ASSET__Cn49ZNNi__"